import { navigation } from '@/config/navigation'
import { onUpdate } from '@codeleap/hooks'

export default function HomePage() {
  onUpdate(() => {
    navigation.navigate('Profile.View')
  }, [])

  return null
}
